import React from 'react';
import { avatarColor, initialsOf } from '../../design/tokens';
import './ui.css';

/** Circular avatar with initials. Colour is derived from the seed so it is stable per person. */
export function Avatar({ name, seed, size = 26, fontSize, className = '' }) {
  return (
    <span
      className={`sv-avatar ${className}`}
      style={{
        width: size,
        height: size,
        background: avatarColor(seed || name),
        fontSize: fontSize || Math.round(size * 0.42),
      }}
      aria-hidden="true"
    >
      {initialsOf(name)}
    </span>
  );
}

/**
 * Table user cell — 26px avatar + name over email, gap 9px.
 * Used by every list screen that shows a person.
 */
export default function UserCell({ name, secondary, seed, size = 26 }) {
  return (
    <div className="sv-user-cell">
      <Avatar name={name} seed={seed} size={size} />
      <div className="sv-user-cell__text">
        <div className="sv-user-cell__name sv-truncate">{name || '—'}</div>
        {secondary && <div className="sv-user-cell__meta sv-truncate">{secondary}</div>}
      </div>
    </div>
  );
}
